import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoginModule } from './component/login/login.module';
import { allIcons, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginService } from './service/login.service';
import { ToastrModule } from 'ngx-toastr';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppService } from './service/app.service';
import { DatePipe } from '@angular/common';
import { BnNgIdleService } from 'bn-ng-idle';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
// import { TreeviewModule } from 'ngx-treeview';
import { LoggingInterceptor } from './interceptor/logging.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './component/header/header.component';
import { ComponentComponent } from './component/component.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { SharedModule } from './shared/shared.module';
import { ForexDerivativesModule } from './component/forex-derivatives/forex-derivatives.module'
import { DerivativeBaseModule } from './component/derivative-base/derivative-base.module';
import { AdminComponent } from './component/admin/admin.component';
import { NewUserApprovalComponent } from './component/admin/new-user-approval/new-user-approval.component';
import { SmallPageLayoutComponent } from './component/small-page-layout/small-page-layout.component';
import { ProfileComponent } from './component/profile/profile.component';
import { AccessDetailsComponent } from './component/admin/access-details/access-details.component';
import { UserListComponent } from './component/admin/user-list/user-list.component';
import { AddUserComponent } from './component/admin/add-user/add-user.component';
import { PNoteModule } from './component/derivative-base/pnote/pnote.module';
import { CommonComponentsModule } from './component/derivative-base/common-components/common-components.module';
import { HolidayMasterComponent } from './component/admin/parameter-master/holiday-master/holiday-master.component';
import { ParameterMasterModule } from './component/admin/parameter-master/parameter-master.module';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { SrgbModule } from './component/srgb/sgrb.module';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    NgxSpinnerModule
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    ComponentComponent,
    DashboardComponent,
    AdminComponent,
    NewUserApprovalComponent,
    SmallPageLayoutComponent,
    ProfileComponent,
    AccessDetailsComponent,
    UserListComponent,
    AddUserComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DataTablesModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoginModule,
    SharedModule,
    CommonComponentsModule,
    ParameterMasterModule,
    HttpClientModule,
    BsDatepickerModule.forRoot(),
    NgxBootstrapIconsModule.pick(allIcons),
    NgxSpinnerModule,
    TimepickerModule.forRoot(),
    // TreeviewModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      extendedTimeOut: 5000,
      progressBar: true,
      progressAnimation: 'decreasing',
      positionClass: 'toast-bottom-right',
      closeButton: true
    }),
    PNoteModule,
    // NgxChartsModule,
    BrowserAnimationsModule,
    CarouselModule,
    SrgbModule
  ],
  providers: [
    BsDatepickerConfig,
    AppService,
    LoginService,
    DatePipe,
    BnNgIdleService,
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
